import { render, staticRenderFns } from "./AdvertisementItem.vue?vue&type=template&id=2b08d336&scoped=true"
import script from "./AdvertisementItem.vue?vue&type=script&lang=js"
export * from "./AdvertisementItem.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementItem.vue?vue&type=style&index=0&id=2b08d336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08d336",
  null
  
)

export default component.exports